/* Existing native variant-card integration; shared initialization for PDP and quick view. */
(function () {
    var NS = window.__bkMediaCvp;
    if (!NS) {
      NS = window.__bkMediaCvp = {};

      NS.getSection = function (el) {
        return el.closest('[id^="ProductSection-"]');
      };

      NS.getThemeInputsRoot = function (section) {
        return section.querySelector('.product-block--bk-cvp .bk-media-cvp__theme-inputs') || section;
      };

      NS.clickThemeOption = function (section, optionKey, value) {
        var root = NS.getThemeInputsRoot(section);
        var inputs = root.querySelectorAll('input[data-variant-input][data-index="' + optionKey + '"]');
        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];
          if (String(input.value) !== String(value)) continue;
          if (input.disabled || input.classList.contains('disabled')) return false;
          var label = input.id
            ? root.querySelector('label.variant__button-label[for="' + input.id.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]')
            : null;
          if (label && !label.classList.contains('disabled')) {
            label.click();
            return true;
          }
          input.click();
          return true;
        }
        return false;
      };

      NS.selectVariantOnTheme = function (section, row) {
        if (!section || !row) return;
        var keys = [];
        ['option1', 'option2', 'option3'].forEach(function (key) {
          if (row.getAttribute('data-' + key)) keys.push(key);
        });
        if (!keys.length) return;

        var index = 0;
        function clickNext() {
          if (index >= keys.length) return;
          var key = keys[index++];
          var value = row.getAttribute('data-' + key);
          NS.clickThemeOption(section, key, value);
          if (index < keys.length) {
            window.setTimeout(clickNext, 0);
          }
        }
        clickNext();
      };

      NS.syncRowSelection = function (wrapper, variantId) {
        if (!wrapper || !variantId) return;
        wrapper.querySelectorAll('.bk-media-cvp__row').forEach(function (row) {
          var selected = row.getAttribute('data-variant-id') === String(variantId);
          row.classList.toggle('bk-media-cvp__row--selected', selected);
          row.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
      };

      NS.updatePresaleBanner = function (wrapper) {
        var banner = wrapper.querySelector('.bk-media-cvp__presale-banner[data-presale-has-content]');
        if (!banner) return;
        var selected = wrapper.querySelector('.bk-media-cvp__row--selected');
        if (!selected || selected.getAttribute('data-presale') !== 'true') {
          banner.classList.remove('is-visible');
          return;
        }
        banner.classList.add('is-visible');
      };

      NS.initWrapper = function (wrapper) {
        if (wrapper.getAttribute('data-cvp-initialized') === 'true') return;
        var section = NS.getSection(wrapper);
        if (!section) return;
        wrapper.setAttribute('data-cvp-initialized', 'true');

        var dialog = wrapper.querySelector('.bk-media-cvp__dialog');
        var openBtn = wrapper.querySelector('.bk-media-cvp__info-trigger');
        if (openBtn && dialog && typeof dialog.showModal === 'function') {
          openBtn.addEventListener('click', function (evt) {
            evt.stopPropagation();
            dialog.showModal();
          });
        }
        if (dialog) {
          var closeBtn = dialog.querySelector('.bk-media-cvp__dialog-close');
          if (closeBtn) closeBtn.addEventListener('click', function () { dialog.close(); });
          dialog.addEventListener('click', function (e) {
            if (e.target === dialog) dialog.close();
          });
        }

        wrapper.querySelectorAll('.bk-media-cvp__row').forEach(function (row) {
          row.addEventListener('click', function () {
            if (row.disabled || row.classList.contains('bk-media-cvp__row--disabled')) return;
            NS.selectVariantOnTheme(section, row);
          });
        });

        section.addEventListener(
          'variantChange',
          function (evt) {
            var variant = evt.detail && evt.detail.variant;
            if (!variant) return;
            NS.syncRowSelection(wrapper, variant.id);
            NS.updatePresaleBanner(wrapper);
          },
          { passive: true }
        );

        var master = section.querySelector('[data-product-select]');
        if (master && master.value) {
          NS.syncRowSelection(wrapper, master.value);
        }
        NS.updatePresaleBanner(wrapper);
      };

      NS.init = function (root) {
        (root || document).querySelectorAll('[data-bk-media-cvp]').forEach(NS.initWrapper);
      };

      document.addEventListener('shopify:section:load', function (evt) {
        NS.init(evt.target);
      });
      document.addEventListener('page:loaded', function () {
        NS.init(document);
      });
      document.addEventListener('quickview:loaded', function (evt) {
        var productId = evt.detail && evt.detail.productId;
        var modal = productId && document.getElementById('QuickShopModal-' + productId);
        NS.init(modal || document);
      });
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { NS.init(document); });
      } else {
        NS.init(document);
      }
    }

    NS.init(document);
  })();
